import { render, staticRenderFns } from "./WebhookDeleteModal.vue?vue&type=template&id=05369dd7&"
import script from "./WebhookDeleteModal.vue?vue&type=script&lang=js&"
export * from "./WebhookDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports